import * as React from "react";
import { Formik, Form, Field } from "formik";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import useWelcomeCustomization from "brand-customization/useWelcomeCustomization";
import { HelpBlock, Button } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import usePermissions from "hooks/usePermissions";
const DEFAULT = {
  news_section: true,
  release_section: true
};
const WelcomePageConfiguration = ({ config = DEFAULT, updateConfig = () => {
} }) => {
  const { t } = useTranslation("enterprise_customization");
  const { isPermitted } = usePermissions();
  const sendTelemetry = useSendTelemetry("feeds");
  const _saveConfig = useCallback(
    (values) => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.CUSTOMIZATION.SHOW_WELCOME_PAGE_FEEDS_EDITED, {
        app_pathname: "welcome"
      });
      updateConfig(values);
    },
    [sendTelemetry, updateConfig]
  );
  const { isReleaseSectionEnabledForBrand, isNewsSectionEnabledForBrand } = useWelcomeCustomization();
  const initialValues = {
    news_section: isNewsSectionEnabledForBrand != null ? isNewsSectionEnabledForBrand : config.news_section,
    release_section: isReleaseSectionEnabledForBrand != null ? isReleaseSectionEnabledForBrand : config.release_section
  };
  const isDisabled = !isPermitted("welcome_page_feeds:edit");
  return /* @__PURE__ */ React.createElement(Formik, { initialValues, onSubmit: _saveConfig, enableReinitialize: true }, ({ dirty, handleSubmit, setFieldValue }) => /* @__PURE__ */ React.createElement(Form, { onSubmit: handleSubmit }, /* @__PURE__ */ React.createElement(Field, { name: "news_section" }, ({ field }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      id: "news-section",
      name: field.name,
      checked: !!field.value,
      onChange: (e) => setFieldValue(field.name, e.target.checked),
      disabled: isDisabled
    }
  ), t("welcome_page.show_news")), /* @__PURE__ */ React.createElement(HelpBlock, null, t("welcome_page.show_news_help")))), /* @__PURE__ */ React.createElement(Field, { name: "release_section" }, ({ field }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("label", { style: { display: "inline-flex", alignItems: "center", gap: 8 } }, /* @__PURE__ */ React.createElement(
    "input",
    {
      type: "checkbox",
      id: "release-section",
      name: field.name,
      checked: !!field.value,
      onChange: (e) => setFieldValue(field.name, e.target.checked),
      disabled: isDisabled
    }
  ), t("welcome_page.show_release")), /* @__PURE__ */ React.createElement(HelpBlock, null, t("welcome_page.show_release_help")))), !isDisabled && /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", bsStyle: "info", type: "submit", disabled: !dirty }, t("welcome_page.update"))));
};
export default WelcomePageConfiguration;
